module.exports = __webpack_public_path__ + "img/no-items.3e4d6b39.svg";